document.documentElement.style.fontSize =
  document.documentElement.clientWidth / 3.75 + 'px'


// WEBPACK FOOTER //
// ./src/utils/rem.js